import { useAppDispatch } from "../../../../redux/hooks";

import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { getDownloadDestroyedProductsRaport } from "../../../../redux/api/inventory.api";
import { ProductsRaportsDestroyedInterface } from "../../../../redux/interfaces/inventory.interface";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { TableItemId } from "../../../../components/tables/TableWidget";

function ProductsDestroyedRaportsActionButton({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: ProductsRaportsDestroyedInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const handleDownloadNrcd = () => {
    if (!crudData?.nr_raport) return;
    dispatch(
      getDownloadDestroyedProductsRaport({
        idRaport: crudData.nr_raport,
      }),
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`Raport ${crudData?.nr_raport ?? ""}`}
      ariaLabel={`Actiuni pentru raportul ${crudData?.nr_raport ?? ""}`}
      items={[
        {
          id: "print-report",
          label: "Retipareste raport",
          icon: "PRINT",
          kind: "preview",
          tooltip:
            "Deschide PDF-ul raportului de distrugere intr-o fila noua pentru vizualizare sau tiparire.",
          onClick: handleDownloadNrcd,
        },
      ]}
    />
  );
}

export default ProductsDestroyedRaportsActionButton;
